import { PointOfInterest } from './poi';
import { Location, Symbol } from './data-models';


export class Unit {
    DisplayName: string;
    Abbreviation: string;
}

export class Attribute {
    Unit: Unit;
    Value: any;
    Name: string;
    DisplayName: string;
    StatusCounter: number;
}

export class Transporter {
    View: TransporterViewModel;
    State: TransporterState;
    POIDetails: TransporterPoi;
    BasicDetails: TransporterBasicDetails;
}
export class TransporterBasicDetails {

    Id: number = 0;
    Code: string;
    CourierTypeId: number = -1;
    PlateNumber: string;
    TypeId: number = -1;
    SubscriberId: number = 1;
    CreatedBy: number;
    CreationDate: Date;
    LastModifiedBy: number = null;
    LastModifiedDate: Date = null;
    isSelected: boolean = false;
    VehicleCapacityUnitId: number = -1;
    VehicleCapacity: string;
    ColorId: number = -1;
    BrandId: number = -1;
    ManufacturerId: number = -1;
    ModelId: number = -1;
    ChassisNumber: string;
    EngineNumber?: string;
    EngineCapacity: string;
    LicenseNumber: string;
    LicenseExpiryDate: any;
    CurrentMileage: number;
    CurrentFuelLevel: number;
    TankCapacity: number = 40;
    Attachments: any[];
    VehicleAttachments: any[];
    PhotoId: string = null;
    FuelBurnRate0: number = 1;
    FuelBurnRate0_100: number = 1;
    FuelBurnRate100: number = 1;
    AccelerationThreshold: number = 80;
    MaxOdometer: number = 200;
    CurrentFuelConsumption: number;
    InsuranceIssueStartDate?: any;
    InsuranceIssueEndDate?: any;
    InsuranceNumber?: any;
    TransporterPictureId?: any;

    NextExaminationDate?: any;
    InsuranceStartDate?: any;
    InsuranceEndDate?: any;
    LicenseIssueDate?: any;
    InsuranceCompany: string;
    ManufacturingDate?: any;
    BranchId: number = -1;
    DriverId: number;
    Number: any;
    VehicleGroupId: number = -1;
    ResourceDeliveryTypeId: number = 1;
    ThreePLServiceProviderId: number;
}

export class TransporterState {

    State: TransporterStateDetail;
}

export class TransporterStateDetail {
    ODO: number;
    TimeStamp: any;
    IButton: string;
    Location: Location;
    Category: Attribute;
    Movement: Attribute;
    IsPanic: Attribute[];
    Sensors: Attribute[];
    LastLocation: Location;
    Violations: Attribute[];
    ConnectivityStatus: Attribute[];
}

export class TransporterViewModel {
    Symbol: Symbol;
    SymbolProperties: Symbol[];
}

export class Driver {
    FirstName: string;
    LastName: string;
}

export class Device {
    CreatedBy: number;
    CreationDate: Date;
    LastUpdatedBy?: number;
    LastUpdatedDate?: Date;
    public Id: number = -1;
    SubscriberId: number = 1;

    public SimCard: string = '';
    public DeviceCode: string = '';
    public ProviderId: number = -1;
    public TransporterPlate: string;
    public DeviceTypeId: number = -1;
    public TransporterId: number = -1;
    public TrackedObjectId: number = -1;
    public SimCardProviderId: number = -1;
    LastModifiedBy: any;
    public DeviceModelId: number = -1;
    TransporterBasicDetails: TransporterBasicDetails;
}

export class RouteObject {
    Id: number = -1;
    CreatedBy: number;
    POITypeId: number;
    RouteLine: string;
    RouteName: string;
    BufferSize: number;
    CreationDate: Date;
    GeographyLine: any;
    RouteStyle: string;
    LastUpdatedBy?: number;
    LastUpdatedDate?: Date;
    SubscriberId: number = 1;
    IsDeleted: boolean = false;
    Routes_POI: RoutePoiObject[];
}

export class RoutePoiObject {
    Id: number;
    ETA: String;
    PoiOrder: number;
    POI: PointOfInterest;
    RoutesId: number = -1;
    IsDeleted: boolean = false;
    IsInSequenceAndDuplicated: boolean = false;
}

export enum TransporterRouteStatus {
    InRoute,
    OutOfRoute,
    NoDataAvailable
}

export class TransporterPoi {
    NextPOI: RoutePoiObject;
    CurrentRoute: RouteObject;
    CurrentPOI: RoutePoiObject;
    PreviousPOI: RoutePoiObject;
    TransporterStatus: TransporterRouteStatus;
}

export enum CapacityDataType {
    string = 1,
    int = 2,
    decimal = 3
}

export enum SecurityLevel {
    edit = 1,
    readonly = 2,
    hidden = 3
}



// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/dataModels/transporter.ts